import {trackMobileDialogViewport} from '@app/utils/mobile-dialog-viewport';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {PrimeNG} from 'primeng/config';
import {environment} from '@env/environment';
import {Select, Store} from '@ngxs/store';
import {SetAppVersion} from '@app/state/sesion/sesion.actions';
import {Observable, Subject} from 'rxjs';
import {SesionState} from '@app/state/sesion/sesion.state';
import {takeUntil} from 'rxjs/operators';
import {removeLegacyStorage} from '@app/service/product-catalog-cache.service';
import {WorkerScheduleService} from '@app/service/worker-schedule.service';
import {LoginService} from '@app/service/login.service';
import {SessionReplayService} from '@app/service/session-replay.service';
import {TemaService} from '@app/service/tema.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

    private unsubscribe$ = new Subject<void>();
    private releaseDialogViewport = () => {};
    @Select(SesionState.getAppVersion) appVersion$: Observable<string>;
    appVersion: string;

    horizontalMenu: boolean;

    darkMode = false;

    menuColorMode = 'light';

    menuColor = 'layout-menu-light';

    themeColor = 'blue';

    layoutColor = 'blue';

    ripple = true;

    inputStyle = 'outlined';
    workerScheduleBlocked = false;
    workerScheduleMessage = 'Estás fuera de tu horario de trabajo. Tus funcionalidades se limitaron.';

    constructor(private primeng: PrimeNG,
                private store: Store,
                private workerSchedule: WorkerScheduleService,
                private loginService: LoginService,
                public sessionReplay: SessionReplayService,
                private tema: TemaService) {}

    ngOnInit() {
        if (typeof window !== 'undefined') {
            this.releaseDialogViewport = trackMobileDialogViewport(window, document.documentElement);
        }
        this.sessionReplay.startMonitoring();
        this.appVersion$.pipe(takeUntil(this.unsubscribe$)).subscribe(av => {
            this.appVersion = av;
        });
        this.primeng.ripple.set(true);
        // El menú de Mirage tiene su propia variante oscura; Avalon la toma de darkMode
        this.tema.oscuro$.pipe(takeUntil(this.unsubscribe$)).subscribe(oscuro => {
            this.darkMode = oscuro;
            this.menuColorMode = oscuro ? 'dark' : 'light';
            this.menuColor = oscuro ? 'layout-menu-dark' : 'layout-menu-light';
        });
        // El catálogo local ahora vive en IndexedDB: el de localStorage (hasta ~5 MB) ya no se usa.
        removeLegacyStorage();
        this.workerSchedule.status$.pipe(takeUntil(this.unsubscribe$)).subscribe(status => {
            this.workerScheduleBlocked = status?.dentroHorario === false
                && status?.tipoRestriccion === 'LIMITAR_ACCIONES';
            if (status?.dentroHorario === false && status?.tipoRestriccion === 'CERRAR_SESION') {
                this.workerSchedule.clear();
                this.loginService.logOut();
            }
        });
        const login = this.loginService.getLogin();
        if (login?.estadoHorarioTrabajador) {
            this.workerSchedule.apply(login.estadoHorarioTrabajador);
        } else if (login) {
            this.workerSchedule.refresh().subscribe(status => this.workerSchedule.apply(status));
        }
        this.getVersion();
    }

    ngOnDestroy(): void {
        this.releaseDialogViewport();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getVersion() {
        fetch(`${environment.endpointApi}/public/version`)
            .then(response => response.json())
            .then(data => {
                if (!this.appVersion) {
                    this.store.dispatch(new SetAppVersion(data.version));
                } else {
                    if (data.version !== this.appVersion) {
                        this.store.dispatch(new SetAppVersion(data.version));
                        alert(`Nueva versión de la aplicación detectada, el navegador se actualizará de inmediato a la versión ${data.version}.`);
                        // @ts-ignore
                        location.reload(true);
                    }
                }
            });
    }

    logoutForSchedule(): void {
        this.workerSchedule.clear();
        this.loginService.logOut();
    }

}
